import 'jcarousellite/jcarousellite.min';
import '../../lib/jquery.tooltipster.min';
import 'featherlight';
import 'jquery.scrollbar';
import { forEachOnObject, size } from '../../lib/utilities';
import ItemFactory from '../cart/item/item_factory';
import Page from './page';
import { updatePostcodeAction } from '../_flux/actions/postcode_actions';
import CartActions from '../_flux/actions/cart_actions';
import LightboxActions from '../_flux/actions/lightbox_actions';
import ActiveStationActions from '../_flux/actions/active_station_actions';
import ActiveStationStore from '../_flux/stores/active_station_store';
import { renderFittingStationFinder } from '../_flux/components/fitting_station_finder/fitting_station_finder';
import prepareInitialStation from '../_flux/helper/initial_state_setup/fitting_station';
import * as FSFMmotoLightBoxActions from '../_flux/actions/fsf_moto_light_box_actions';
import { setSkuAction, setTypeAction, showAction as showNotifyMeAction } from '../_flux/actions/notify_me_actions';
import FittingStationFinderConstants from '../_flux/constants/fitting_station_finder_constants';
import { NotificationTypes } from '../_flux/constants/notify_me/notification_types';
import API from '../API/api';
import { init as initWheelAlignmentInfoLightBox } from '../_views/wheel_alignment_info_light_box/wheel_alignment_info_light_box_view';
import { init as initFSRemoveLightBox } from '../_views/fs_remove_light_box/fs_remove_light_box_view';
import { init as initCrossSellRemoveLightBox } from '../_views/cross_sell_remove_light_box/cross_sell_remove_light_box_view';
import {
  init as initCrossSellLightBox,
  onClose as crossSellLightBoxClose,
} from '../_views/cross_sell_light_box/cross_sell_light_box_view';
import TyreActions from '../_flux/actions/tyre_actions';
import FittingStationStore from '../_flux/stores/fitting_station_store';
import ProductPage from './product_page';
import { addAction } from '../_flux/actions/products_actions';
import { init as initSidebarCart } from '../_views/sidebar/cart';
import { types } from '../_constants/product/types';
import { init as initPostcodeLightBox } from '../_views/postcode_light_box/postcode_light_box';
import { init as initUiLock } from '../_views/ui_lock/ui_lock_view';
import { init as initNotifyMe } from '../_views/notify_me/notify_me';
import { init as initFSFMmotoLightBoxView } from '../_views/fsf_moto_light_box/fsf_moto_light_box_view';
import { init as initWheelAlignmentInfoLightBoxView } from '../_views/wheel_alignment_info_light_box/wheel_alignment_info_light_box_view';
import { init as initFriendbuyBoxView } from '../_views/friendbuy_light_box/friendbuy_light_box';
import { init as initSidebarLightBoxView } from '../_views/sidebar/light_box';
import loadQualieTestimonials from '../utilities/qualie';
import autoOpenFsf from '../utilities/fsf/auto_open';
import { init as initClearanceInfoLightBox } from '../_views/clearance_info_light_box/clearance_info_light_box';
import bindClearanceEvent from '../_flux/helper/clearance_info_click_event';
import { getPostcodeFromLocalStorage } from '../utilities/local_storage';
import { showAutoCompletePostcodeSelector } from '../_flux/components/PostcodeAutocomplete';
import {
  getCsrfTokenKeyParamName,
  getCsrfTokenKey,
  getCsrfTokenValueParamName,
  getCsrfTokenValue,
} from '../utilities/csrf_token_provider';
import {
  init as initVoucherCodeLightBox,
  onClose as voucherCodeLightBoxClose,
} from '../_views/voucher_code_light_box/voucher_code_light_box_view';
import CheckoutAddressPage from './checkout_address_page';

/**
 * @extends Page
 */
class CartPage extends Page {
  static _name = 'CartPage';

  /**
   * @extends Page
   * @param {Object} $container [jQuery]
   * @param {FlashMessages} flashMessages
   */
  constructor($container, flashMessages) {
    super($container, flashMessages);

    this.items = {};
    this.$fittingStationPostcode = $('#fittingStationPostcode');
    this.$optionsAddress = $('[name="optionsAddress"]');
  }

  init() {
    super.init();

    if (!this.$container.length) {
      return;
    }

    this.initItems();
    this.initOutOfStockHandler();
    this.initVoucherHandler();
    // loadQualieTestimonials();
    initClearanceInfoLightBox(document.getElementById('clearance-info'));
    bindClearanceEvent();
    const voucherClick = document.querySelector('.voucher-form__click');
    voucherClick.addEventListener('click', () => {
      const voucherContainer = document.querySelector('.voucher-form__input-container');
      voucherContainer.style.display = 'block';
      voucherClick.style.display = 'none';
    });

    if (document.getElementById('pdp-sidebar')) {
      if (size(TYROOLA.initialFluxStates.products) === 1) {
        // trigger opt out wheel alignment if there's only one product in the cart
        TyreActions.updateQtyAction(4);
      }

      TYROOLA.initialFluxStates.products.forEach(addAction);
      prepareInitialStation(this.getInitialStation());

      if (TYROOLA.initialFluxStates.products.length === 1) {
        TyreActions.updateBrandAction(TYROOLA.initialFluxStates.products[0].brand);
      }
      TyreActions.updateQtyAction(TYROOLA.initialFluxStates.totalQty);

      const initialStation = TYROOLA.initialFluxStates.initialStation;
      const wheelAlignmentExpenses = initialStation && initialStation.expenses.wheelAlignment;
      if (initialStation && wheelAlignmentExpenses && wheelAlignmentExpenses.wheels_2 > 0) {
        this._onWheels2Change(initialStation.id, true);
      }

      if (initialStation && wheelAlignmentExpenses && wheelAlignmentExpenses.wheels_4 > 0) {
        this._onWheels4Change(initialStation.id, true);
      }

      initCrossSellLightBox(document.getElementById('cross-sell'), {});

      const doesCartContainsCarTyresOnly = this.cartContainsCarTyresOnly();
      this.initSidebar(doesCartContainsCarTyresOnly);

      initWheelAlignmentInfoLightBox(document.getElementById('wheel-alignment-info'), {
        onRemove: ProductPage.onRemoveWheelAlignment.bind(this, 'cart'),
      });

      initFSRemoveLightBox(document.getElementById('fs-remove'), {
        onRemove: ProductPage.onRemoveFittingStation.bind(this, true),
      });

      initPostcodeLightBox(document.getElementById('postcode-light-box'));
      initUiLock(document.getElementById('ui-lock'));

      if (doesCartContainsCarTyresOnly) {
        this.initFittingStationFinder();
        autoOpenFsf();
      } else {
        this.initMotoFittingStationFinder();
      }

      initWheelAlignmentInfoLightBoxView(document.getElementById('wheel-alignment-info'), {
        onRemove: ProductPage.onRemoveWheelAlignment.bind(this, 'cart'),
      });

      initFriendbuyBoxView(document.getElementById('wheel-alignment-info'), {
        staticUrl: TYROOLA.globals.staticUrl,
        baseUrl: TYROOLA.globals.baseUrl,
        storeUrl: TYROOLA.globals.storeUrl,
      });

      initSidebarLightBoxView(document.getElementById('sidebar-light-box'), {
        currencyIsoCode: TYROOLA.globals.currencyIsoCode,
      });
    }

    initVoucherCodeLightBox(document.getElementById('voucher-code'), {
      onRedeem: CheckoutAddressPage.onRedeem.bind(this),
    });
  }

  static removeWheelAlignmentFromCart() {
    CartActions.loadCartAction(true);
    const initialStation = TYROOLA.initialFluxStates.initialStation;

    if (initialStation) {
      ActiveStationActions.unsetWheelAlignment('2', initialStation.id);
      ActiveStationActions.unsetWheelAlignment('4', initialStation.id);
    }
  }

  /**
   * @returns {boolean}
   */
  cartContainsCarTyresOnly() {
    return !document.querySelector('.cart-item--moto');
  }

  initMotoFittingStationFinder() {
    initFSFMmotoLightBoxView(document.getElementById('fsf-moto'));
  }

  getInitialStation() {
    if (TYROOLA.initialFluxStates.initialStation.id) {
      return TYROOLA.initialFluxStates.initialStation;
    }

    return null;
  }

  /**
   * @returns {CartPage}
   */
  initItems() {
    'use strict';
    var factory = new ItemFactory();
    this.items['dropdown'] = factory.getDropdowns(this.$container);
    return this;
  }

  /**
   * @return {CartPage}
   */
  initOutOfStockHandler() {
    $('.notify-me__a').on('click', (event) => {
      const productSku = $(event.target).attr('data-product-id');
      const product = TYROOLA.initialFluxStates.products[productSku];

      if (product) {
        const notificationType =
          product.stock === 0 || product.stock === null
            ? NotificationTypes.OUT_OF_STOCK
            : NotificationTypes.LOW_ON_STOCK;
        setSkuAction(productSku);
        setTypeAction(notificationType);
        showNotifyMeAction();
      }
    });

    initNotifyMe(document.getElementById('cart-notify-me'));
    return this;
  }

  /**
   * @return void
   */
  initVoucherHandler() {
    'use strict';
    $('#voucher-trigger').on('click', function (e) {
      e.preventDefault();
      $('#voucher-container').show();
    });
  }

  initFittingStationFinder() {
    let initialStation = TYROOLA.initialFluxStates.initialStation.id ? TYROOLA.initialFluxStates.initialStation : null;
    prepareInitialStation(initialStation);

    renderFittingStationFinder({
      containerDOMNode: document.getElementById('fsf'),
      showSelectStationButton: true,
      showSuccessPage: false,
      showQuantityInput: false,
      onStationSelect: this._onStationSelect.bind(this),
      onWheels2Change: this._onWheels2Change.bind(this),
      onWheels4Change: this._onWheels4Change.bind(this),
    });
  }

  _onStationSelect(newStation) {
    const activeStationStoreState = ActiveStationStore.getState();
    const wheelAlignment2 = activeStationStoreState.wheelAlignment.wheels2.indexOf(newStation.id) !== -1;
    const wheelAlignment4 = activeStationStoreState.wheelAlignment.wheels4.indexOf(newStation.id) !== -1;

    // applyPostcodeAction(newStation.postcode);
    ActiveStationActions.setActiveStationAction(newStation, true, wheelAlignment2, wheelAlignment4).then(
      CartActions.loadCartAction,
    );
  }

  initSidebar(doesCartContainCarTyresOnly) {
    this._setInitialPostcode();
    this._setInitialCartData();

    initSidebarCart(document.querySelector('#pdp-sidebar'), {
      tyreType: doesCartContainCarTyresOnly ? types.TYRE_CAR : types.TYRE_MOTO,
      currencyIsoCode: TYROOLA.globals.currencyIsoCode,
      baseUrl: TYROOLA.globals.baseUrl,
    });
  }

  _setInitialPostcode() {
    // TODO: verify from where this postcode is coming from
    const postcode = showAutoCompletePostcodeSelector(TYROOLA.globals.store)
      ? getPostcodeFromLocalStorage()
      : $('[data-postcode]').attr('data-postcode');

    if (postcode) {
      updatePostcodeAction(postcode, false);
    }
  }

  _setInitialCartData() {
    // var shipping = this._getInitialShipping();
    // var fitting = $('.sidebar-summary__data--fitting .summary-row__price').html();
    // var discount = $('.sidebar-summary__data--discount .summary-row__price').html();
    // var total = $('.product-totals__price').html();
    // var rrpSavings = $('.sidebar-summary__data--retail-price .cart-retail-savings').html();
    // var shippingTime = $('.sidebar__shipping-time strong').html();

    // if (shipping) {
    //     if (shipping.match(/Calculate/)) {
    //         shipping = '';
    //     }
    //     if (shipping.match(/free-fitting/)) {
    //         shipping = '<span class="free-shipping">Free</span>';
    //     }
    // }

    const { initialFluxStates } = TYROOLA;

    CartActions.updateCartAction({
      cart: {
        productCount: initialFluxStates.products.length,
        totalToPay: initialFluxStates.total || -1,
        totalWithoutExpenses: -1,
        totalShipping: initialFluxStates.shipping || -1,
        totalFittingCost: initialFluxStates.fitting || -1,
        totalDiscount: initialFluxStates.discount || -1,
        totalRrpSavings: initialFluxStates.rrpSavings || -1,
        discountInfo: initialFluxStates.discountInfo || {},
        shippingTime: initialFluxStates.shippingTime || '',
      },
    });
  }

  static _setCartData() {
    CartActions.loadCartAction(true);
  }

  _onWheels2Change(stationId, isChecked) {
    const action = isChecked ? ActiveStationActions.setWheelAlignment : ActiveStationActions.unsetWheelAlignment;
    action('2', stationId);
  }

  _onWheels4Change(stationId, isChecked) {
    const action = isChecked ? ActiveStationActions.setWheelAlignment : ActiveStationActions.unsetWheelAlignment;
    action('4', stationId);
  }

  static _onPostcodeChange(postcode) {
    // TODO: verify from where this postcode is coming from
    const apiPath = FittingStationFinderConstants.SET_FITTING_STATION_API_URL;
    const data = { postcode };

    API.GET({ apiPath, data }).then(CartActions.loadCartAction.bind(CartActions));
  }
}

export default CartPage;
